export const lStorage = (function() {
	// Interacting with localStorage.
	var ls = {};

	ls.hasData = ({ key }) => !!localStorage[key] && !!localStorage[key].length;

	ls.get = ({ key, stringify = true }) => {
		if (!lStorage.hasData({ key })) {
			return false;
		}
		var data = localStorage[key];

		try {
			return stringify ? JSON.parse(data) : data;
		} catch (e) {
			return data;
		}
	};

	ls.set = ({ key, value, stringify = true }) => {
		try {
			localStorage.setItem(key, stringify ? JSON.stringify(value) : value);
		} catch (e) {
			localStorage.setItem(key, value);
		}
	};

	ls.remove = ({ key }) => localStorage.removeItem(key);

	return ls;
})();
